import React, { useEffect, useState } from 'react';
import { Row, Col } from 'tea-component';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { connect, useDispatch, useHistory, useIntl } from 'umi';
import Regions from './regions';
import './index.scss';

import Mentions from './mentions';

// https://partner.coding.intlgame.com/p/dic_out/d/databrain-opinion-pc/git/commit/5602dae19d6e0196e376b4526cc575a11b135232
// 接口调整，需要修改

function RegionMarket(props: any) {
  const { formatMessage } = useIntl();

  const {
    userInfo,
    gameInfo,
    filter,
    regionLoading = true,
    countryLoading = false,
  } = props;

  const [regionType, setRegionType] = useState<any>('region');
  const dispatch = useDispatch();
  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;

    dispatch({
      type:
        regionType === 'region'
          ? 'opinionPerformance/getOverviewRegion'
          : 'opinionPerformance/getOverviewCountry',
      payload: {
        ...filter,
        ...gameInfo,
        user_id: userInfo.userid,
        region_stats_method: regionType,
        statistics_field: 'region',
      },
    });
  }, [regionType, userInfo, gameInfo, filter]);
  const { mentions = [], timeline_of_mentions } = props.region;

  const history = useHistory();
  return (
    <Row className="dbo-cardrow-wrap dbo-performance-region">
      <Col>
        <CardCommon
          loading={regionLoading || countryLoading}
          loadingHeight={340}
          emptyHeight={340}
          empty={
            (!Array.isArray(mentions) || mentions.length === 0) &&
            (!Array.isArray(timeline_of_mentions) ||
              timeline_of_mentions.length === 0)
          }
          hasTitleArrow
          handleTitleOnClick={() => history.push('/opinion/Stats/Region')}
          title={formatMessage({ id: 'Region/Country' })}
          filters={[
            { text: 'Region', value: 'region' },
            { text: 'Country', value: 'market' },
          ].map((item) => ({
            ...item,
            text: formatMessage({ id: item.text }),
          }))}
          handleFilterOnChange={(type) => setRegionType(type)}
        >
          <Row>
            <>
              <Col span={12}>
                <div className="echart-data worldMap">
                  <Regions data={mentions} regionType={regionType}></Regions>
                </div>
              </Col>
              <Col span={12}>
                <div className="echart-data">
                  <Mentions
                    data={props.region}
                    filter={props.filter}
                    regionType={regionType}
                  ></Mentions>
                </div>
              </Col>
            </>
          </Row>
        </CardCommon>
      </Col>
    </Row>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionCommon, opinionPerformance } = state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
    regionLoading: loading.effects['opinionPerformance/getOverviewRegion'],
    countryLoading: loading.effects['opinionPerformance/getOverviewCountry'],
    region: opinionPerformance.region,
  };
})(RegionMarket);
